// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"menu_buttonWrapper__nrs8B","button":"menu_button__Nh0DM","text":"menu_text__1l_R6"};